// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38oAp","textarea":"styles_textarea__2Otop"};